// @flow
import React, { FC, ReactNode, useState, useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { count } from 'console';

const VirtualRenderDiv = styled('div')({
    overflowX: 'auto',
});

// cant be same as display rows count, will not make scroll element then, al will be not able to scroll
const rowsInc = 10;

type VirtualRenderPropsType = {
    rows: any[];
    maxHeight: number;
    renderRow: (row: any) => ReactNode;
    rowId: string;
    initRows?: number;
};

const VritualRender: FC<VirtualRenderPropsType> = (props) => {
    const elmRef = useRef<HTMLDivElement>(null);
    const [renderRows, setRenderRows] = useState(props.initRows || 10);

    useEffect(() => {
        if (props.rows && props.rows.length < renderRows - rowsInc) {
            setRenderRows(renderRows - rowsInc);
        }
    }, [props.rows]);

    const checkScrollIncrement = () => {
        if (renderRows < props.rows.length) {
            const element = elmRef.current;
            if (element && element.scrollHeight < element.scrollTop + element.offsetHeight + 10) {
                setRenderRows(renderRows + rowsInc);
            }
        }
    };

    return (
        <VirtualRenderDiv ref={elmRef} style={{ maxHeight: props.maxHeight }} onScroll={checkScrollIncrement}>
            {props.rows.slice(0, renderRows).map((row) => (
                <div key={row[props.rowId]}>{props.renderRow(row)}</div>
            ))}
        </VirtualRenderDiv>
    );
};

export default VritualRender;
